import { z } from 'zod';

// ── Embedded mentor entity ──────────────────────────────
const WithdrawMentorApiSchema = z
  .object({
    id_user: z.string(),
    full_name: z.string(),
    email: z.string(),
    phone_number: z.string().nullable().optional(),
    bank_name: z.string().nullable().optional(),
    bank_account_number: z.string().nullable().optional(),
    bank_account_holder_name: z.string().nullable().optional(),
  })
  .transform(raw => ({
    idUser: raw.id_user,
    fullName: raw.full_name,
    email: raw.email,
    phoneNumber: raw.phone_number ?? null,
    bankName: raw.bank_name ?? null,
    bankAccountNumber: raw.bank_account_number ?? null,
    bankAccountHolderName: raw.bank_account_holder_name ?? null,
  }));

export type WithdrawMentorDTO = z.infer<typeof WithdrawMentorApiSchema>;

// ── Withdrawal API shape → transform to DTO ─────────────
const WithdrawalApiSchema = z
  .object({
    id_withdrawal: z.number(),
    mentor: WithdrawMentorApiSchema.nullable().optional(),
    amount: z.number(),
    status: z.string(),
    transfer_proof: z.string().nullable().optional(),
    requested_at: z.string(),
    completed_at: z.string().nullable().optional(),
    created_at: z.string(),
    updated_at: z.string(),
  })
  .transform(raw => ({
    idWithdrawal: raw.id_withdrawal,
    mentor: raw.mentor ?? null,
    amount: raw.amount,
    status: raw.status,
    transferProof: raw.transfer_proof ?? null,
    requestedAt: raw.requested_at,
    completedAt: raw.completed_at ?? null,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  }));

export type WithdrawalDTO = z.infer<typeof WithdrawalApiSchema>;

export function toWithdrawalDTO(raw: unknown): WithdrawalDTO {
  return WithdrawalApiSchema.parse(raw);
}

// ── Paginated response ─────────────────────────────────
const GetWithdrawalsPaginationApiSchema = z
  .object({
    result: z
      .object({
        data: z.array(WithdrawalApiSchema),
        total_data: z.number(),
        per_page: z.number(),
        current_page: z.number(),
        last_page: z.number(),
        first_page: z.number(),
      })
      .transform(raw => ({
        data: raw.data,
        totalData: raw.total_data,
        perPage: raw.per_page,
        currentPage: raw.current_page,
        lastPage: raw.last_page,
        firstPage: raw.first_page,
      })),
  })
  .transform(raw => raw.result);

export type GetWithdrawalsPaginationDTO = z.infer<
  typeof GetWithdrawalsPaginationApiSchema
>;

export function toGetWithdrawalsPaginationDTO(
  raw: unknown
): GetWithdrawalsPaginationDTO {
  return GetWithdrawalsPaginationApiSchema.parse(raw);
}
